// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '用户名',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入用户名'
        }]
    },
    url: {
        title: '权限',
        type: 'select',
        multi: true,
        items: [],
        value: [],
        rules: [{
            required: true,
            message: '请选择权限'
        }],
        extra: {
            hint: '建议将“首页”给所有需要登录本系统的角色，否则登录后会出现 401 错误'
        }
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [
    {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        ...columnPublicConfig,
    },
    {
        title: '权限',
        dataIndex: 'url',
        key: 'url',
        scopedSlots: {
            customRender: 'c-url'
        },
        ...columnPublicConfig,
    },
    {
        title: '更新时间',
        dataIndex: 'updated_time',
        key: 'updated_time',
        ...columnPublicConfig
    },
    {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 200,
        scopedSlots: {
            customRender: 'c-action'
        }
    }
]
